import { render } from "./AddParent.vue?vue&type=template&id=b6b899a0&scoped=true&ts=true"
import script from "./AddParent.vue?vue&type=script&lang=ts"
export * from "./AddParent.vue?vue&type=script&lang=ts"

import "./AddParent.vue?vue&type=style&index=0&id=b6b899a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6b899a0"]])

export default __exports__